import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-update-obs-cobro',
  templateUrl: './update-obs-cobro.component.html',
  styleUrls: ['./update-obs-cobro.component.scss']
})
export class UpdateObsCobroComponent implements OnInit {

  public observacion: string;
  public nueva_observacion: string;

  /**
   * Constructor
   * 
   * @param _data 
   * @param {MatDialogRef<UpdateObsCobroComponent>} dialog 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    public dialog: MatDialogRef<UpdateObsCobroComponent>,
  ) 
  { 
    this.observacion = this._data.observacion;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Recibe el argumento 'observacion', y cierra el modal retornando este valor
   * @param {string} observacion 
   */
  public guardarObservacion(observacion: string): void{
    this.observacion = this.observacion ? this.observacion + "\n\r" + observacion : observacion;
    this.dialog.close(this.observacion);
  }

}
